import {PreciosSection} from '@/components/partner-detail/precios-section'
import {SuscripcionesSection} from '@/components/partner-detail/suscripciones-section'
import {FacturasSection} from '@/components/partner-detail/facturas-section'
import {CicloSection} from '@/components/partner-detail/ciclo-section'
import type {Partner} from '@/hooks/inci/aliados/use-partners'

export function BillingSection({partner}: {partner: Partner}) {
  return (
    <div className="space-y-4" data-testid="partner-detail-billing">
      <PreciosSection partnerId={partner.partner_id} />
      <SuscripcionesSection partnerId={partner.partner_id} />
      <FacturasSection partnerId={partner.partner_id} />
      <CicloSection partner={partner} />
    </div>
  )
}
